import { useNavigate } from 'react-router-dom'
import type { BalanceInfo } from '../../lib/api'
import Skeleton from './Skeleton'
import { haptics } from '../../lib/haptics'

interface Props {
  balance: BalanceInfo | null
}

export default function BalanceChip({ balance }: Props) {
  const navigate = useNavigate()

  if (!balance) {
    return <Skeleton width="64px" height="28px" rounded="full" />
  }

  return (
    <button
      onClick={() => {
        haptics.impact('light')
        navigate('/')
      }}
      className="flex items-center gap-1 px-3 py-1.5 rounded-full text-[13px] font-medium tabular-nums min-h-[32px] active:opacity-70 transition-opacity"
      style={{
        backgroundColor: 'var(--tg-theme-secondary-bg-color)',
        color: 'var(--tg-theme-hint-color)',
      }}
    >
      ${balance.creditsUsd.toFixed(2)}
    </button>
  )
}
